import type { SortedSpecType } from "../../../../../common-deprecated/types/SpecTypes";
import type { ExtraType } from "../../../../../common-deprecated/types/CommonTypes";

export const SPECS_SET_SPECS = "specs/setSpecs" as const;
export const SPECS_INVALIDATE_SPECS = "specs/invalidateSpecs" as const;

export type SetSpecsType = {
    type: typeof SPECS_SET_SPECS;
    techSpecs: SortedSpecType[];
    standardEquipment: ExtraType[];
};

export type InvalidateSpecsType = {
    type: typeof SPECS_INVALIDATE_SPECS;
};

export const setSpecs = (techSpecs: SortedSpecType[], standardEquipment: ExtraType[]): SetSpecsType => ({
    type: SPECS_SET_SPECS,
    techSpecs,
    standardEquipment,
});

export const invalidateSpecs = (): InvalidateSpecsType => ({
    // This is used to easily refetch the specs while still displaying the old ones
    type: SPECS_INVALIDATE_SPECS,
});

export type SpecActionsType = SetSpecsType | InvalidateSpecsType;
